import {
    createFormSelectionControlComponent,
    FormSelectionControl,
} from '@vfde-brix/form-selection-control';

/**
 * Mounts the switch (formSelectionControl) component
 * @param selector ID of the switch container
 * @param toggleAction Callback function to be called on change (e. g. action dispatcher function)
 * @param checked Boolean checked state
 * @param autocompleteOff Optional boolean, if true 'autocomplete=off' will be set on the input element
 */
export const mountSwitch = (selector: string, toggleAction, checked: boolean, autocompleteOff = false): FormSelectionControl => {
    const container = document.getElementById(selector);

    const onChange = () => {
        toggleAction();
    };

    const hardwareSwitch = createFormSelectionControlComponent(container, {onChange});

    updateFormSelectionControl(hardwareSwitch, checked, autocompleteOff);

    return hardwareSwitch;
};

/**
 * Updates the formSelectionControl component
 * @param component The formSelectionControl component instance
 * @param checked Boolean checked state
 * @param autocompleteOff If true 'autocomplete=off' will be set on the input element
 */
const updateFormSelectionControl = (component: FormSelectionControl, checked: boolean, autocompleteOff: boolean) => {
    const { items } = component.getProperties();

    items[0].optState = checked ? 'checked' : '';
    items[0].optAutoCompleteOff = autocompleteOff;

    component.update({items});
};
